<template>
    <el-col :xs="{span:24}" :md="width" v-show="show">
        <el-form-item 
            :class="className"
            :label="displayName" 
            :prop="name"
            :rules="rules">
            <input :name="fieldName" :value="data[name]" hidden="hidden">
            <div class="member-select-pane el-input el-input--default selectItem-Button" :class="disabled ? 'is-disabled' : ''" @click="showSelectZone">
                <el-icon><circle-plus /></el-icon> <span style="margin-left:5px">{{ buttonName }}</span>
            </div>
            <div class="top8 member-select-pane el-input el-input--default well-warpper" v-if="selfSetting.IsShowValue" v-show="selectItems.length > 0">
                <div class="well well-item" 
                    v-for="(item,index) in selectItems"
                    :key="index" 
                    @click="showFormDetial(item.ContentItemId)">
                    <div class="well-box">
                        <div class="well-content">
                            <div class="field" v-for="(field,index) in displayFields"
                                :key="index">
                                {{ item[field] }}
                            </div>
                        </div>
                        <el-icon class="well-delete" color="#F56C6C" @click.stop="deleteItem(item.ContentItemId)"><delete /></el-icon>
                    </div>
                </div>
            </div>
            <div class="top8 member-select-pane el-input el-input--default" v-if="selfSetting.IsShowValue" v-show="selectItems.length == 0">
                暂未选择数据
            </div>
            <div class="hint"><i>{{ hint }}</i></div>
        </el-form-item>
        <el-dialog
            lock-scroll
            top="10vh"
            class="contentPickerDetail"
            append-to-body
            v-model="visibleState"
            title="数据详情"
            width="70%">
            <qweForm isPropMode
                    :propDatas="propDatas"
                    :display="true"
                    :is-show-head="false"></qweForm>
        </el-dialog>
        <el-dialog
            destroy-on-close
            lock-scroll
            fullscreen
            append-to-body
            class="grid-picker"
            v-model="gridState"
            :title="buttonName">
            <qweGrid 
                @SelectChange="selectEvent"
                isPropMode
                :propDatas="filters"
                :gridId="gridId">
            </qweGrid>
            <template #footer>
                <el-button type="success" @click="sumbit">确认</el-button>
                <el-button @click="gridState = false">取消</el-button>
            </template>
        </el-dialog>
    </el-col>
</template>

<style>
    .well-box{
        position: relative;
    }

    .well-content{
        padding-right: 10px;
    }

    .well-delete{
        padding: 3px !important;
        height: 20px;
        width: 20px;
        position: absolute;
        top: 0px;
        right: -16px;
        display: none;
    }

    .well:hover{
        box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16), 0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09);
    }

    .well:hover .well-delete{
        display: block;
    }

    .is-disabled{
        background-color: #f5f7fa;
    }

    .grid-picker{
        display: flex;
        flex-direction: column;
    }
    .grid-picker>.el-dialog__body{
        flex-grow: 1;
        padding-bottom: 10px;
    }

    .grid-picker>.el-dialog__footer{
        display: flex;
    }

    .well-warpper{
        padding: 10px 0 0 10px !important;
        display: flex;
        flex-wrap: wrap;
    }

    .contentPickerDetail{
        height: 80% !important;
        display: flex;
        flex-direction: column;
    }

    .contentPickerDetail .el-dialog__body{
        flex-grow: 1;
    }

    .field{
        margin-bottom: 5px;
    }
    .selectItem-Button{
        display: flex;
        align-items: center;
    }
</style>

<script>
    import QweForm from "../../Form/FormItem.vue"
    import ContentPickerField from "./BaseContentPickerField"
    import { CirclePlus, Delete } from '@element-plus/icons-vue'
    import qweGrid from "../../Grid/GridItem.vue"
    

    export default {
        name:"ContentPickerField",
        mixins:[ContentPickerField],
        components:{
            "qweForm":QweForm,
            "circle-plus":CirclePlus,
            "qweGrid":qweGrid,
            "delete":Delete
        }
    }
</script>